import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheets';
import CustomerViewRightPanel from '../CRML2PageComponents/customerview-rightpanel';

type Props = {
  open;
  setOpen: (val: boolean) => void;
  customerId: number;
  isDataLoading: boolean;
  nextSteps: { [key: string]: any }[];
  actions: { [key: string]: string };
  fromSmartFilters: boolean;
  fetchCustomerViewData: (customerId: number) => void;
  getCustomerLevelSuggestedActions: (customerId: number) => void;
};

const InsightsSuggestions = ({
  open,
  setOpen,
  customerId,
  isDataLoading,
  nextSteps,
  actions,
  fromSmartFilters,
  fetchCustomerViewData,
  getCustomerLevelSuggestedActions,
}: Props) => {
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        side="right"
        className="bg-white top-0 bottom-0 h-auto p-0 flex flex-col gap-0"
        closeButtonCls="text-primary-dark"
      >
        <SheetHeader className="px-5 pt-4 pb-2">
          <SheetTitle className="font-bold text-base">
            ZipAI Suggestions
          </SheetTitle>
        </SheetHeader>
        <div className="h-full overflow-y-auto">
          <CustomerViewRightPanel
            customerId={customerId}
            isDataLoading={isDataLoading}
            nextSteps={nextSteps}
            actions={actions}
            showTalkingPoints={fromSmartFilters}
            fetchCustomerViewData={fetchCustomerViewData}
            fetchCustomerSuggestedActions={getCustomerLevelSuggestedActions}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default InsightsSuggestions;
